import axios, { AxiosError, AxiosResponse } from 'axios';
import blobErrorToObject from 'helpers/blobErrorToObject';
import { ISignUpData } from 'interfaces';

const auth_instance = axios.create({
  baseURL: window.REACT_APP_EXTERNAL_AUTH !== 'REPLACE_REACT_APP_EXTERNAL_AUTH' ? window.REACT_APP_EXTERNAL_AUTH : process.env.REACT_APP_EXTERNAL_AUTH || 'https://test.tazadeal.com/auth', // http://localhost:8000/api',
  headers: { 'Access-Control-Allow-Origin': '*' },
  withCredentials: true,
});

auth_instance.interceptors.response.use(( response: AxiosResponse ) => {
  return response
}, async (error: AxiosError<any>) => {
  if (error?.response?.data.constructor.name === 'Blob'){
    error.response.data = await blobErrorToObject(error?.response?.data)
  };
  return Promise.reject(error)
});

const getLoginUrl = (payload: FormData) => auth_instance.post<any>('/blitz/login/url/', payload);
const loginInternal = (payload: FormData) => auth_instance.post<any>('/blitz/login/internal/', payload);
const logoutHandle = (token: string) => auth_instance.post<any>('/blitz/logout/url/', {}, { headers: { 'Authorization': `Bearer ${token}` } });

const refreshBlitzTokens = (payload: { refresh_token: string }) => auth_instance.post<any>('/blitz/auth/refresh/', payload.refresh_token);

const resendVerifyCode = (payload: { email: string }) => auth_instance.post<any>(`/blitz/register/verify/resend/`, {code: 'code', type: 'email', context: 'context'});
const verifyRegister = (payload: { context: string, phone_code?: string, email_code?: string }) => auth_instance.post<any>(`/blitz/register/verify/`, payload);
const blitzRegister = (payload: ISignUpData, browser_data: string) => auth_instance.post<any>(`/blitz/register/`, payload, { params: {browser_data} });

const external_auth = {
  getLoginUrl,
  loginInternal,
  logoutHandle,
  refreshBlitzTokens,
  resendVerifyCode,
  verifyRegister,
  blitzRegister,
};

export default external_auth;
